module.exports = __webpack_public_path__ + "img/ffxstrjn.d4c65244.png";